import { Menu, X } from "lucide-react";
import { useState } from "react";

export function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="nav">
      <div className="page nav__row">
        <a className="nav__mark" href="#top" aria-label="GiveHere home">
          <img src="/brand-mark.svg" alt="" width="30" height="30" />
          GiveHere
        </a>
        <nav className={open ? "nav__links is-open" : "nav__links"} aria-label="Page sections">
          <a href="#how-it-works" onClick={() => setOpen(false)}>
            How it works
          </a>
          <a href="#organizers" onClick={() => setOpen(false)}>
            For organizers
          </a>
          <a href="#questions" onClick={() => setOpen(false)}>
            Questions
          </a>
          <a className="btn btn--primary btn--small" href="#demo" onClick={() => setOpen(false)}>
            Book a demo
          </a>
        </nav>
        <button
          className="nav__toggle"
          aria-label={open ? "Close navigation" : "Open navigation"}
          aria-expanded={open}
          onClick={() => setOpen((value) => !value)}
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
}
